module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt-4 col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "tckBtn radius-normal pointer border-darker text-center d-flex flex-column justify-content-center",
    on: {
      "click": function($event) {
        return _vm.getTickets(true)
      }
    }
  }, [_vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "tckBtn radius-normal pointer border-darker text-center d-flex flex-column justify-content-center",
    on: {
      "click": function($event) {
        return _vm.getTickets(false)
      }
    }
  }, [_vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('i', {
    staticClass: "ico ico-print m-0 fs-super"
  })]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-600 mt-2 fs-larger"
  }, [_vm._v("Print Tickets")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('i', {
    staticClass: "ico ico-email m-0 fs-super"
  })]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-600 mt-2 fs-larger"
  }, [_vm._v("Email Tickets")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60a085f6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationsBulkActions/areaTickets.vue
// module id = 1883
// module chunks = 0